/*** IMPORTS FROM imports-loader ***/
var define = false;

import has from './_has.js';

// Memoize an expensive function by storing its results.
export default function memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!has(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/memoize.js
// module id = 170
// module chunks = 0